import BaseModal       from '../components/BaseModal/index.js';
import BaseModalMedia  from '../components/BaseModal.Media.js';
import BaseModalInline from '../components/BaseModal.Inline.js';

/**
 * Configure and initialize BaseModal
 */
export default function modal() {
    // Define settings for BaseModal
    // Full reference configuration with all available options
    const settings = {
        // ========================================
        // CORE SETTINGS
        // ========================================
        openTrigger :'data-basemodal-trigger',  // Data attribute for trigger elements
        closeTrigger:'data-basemodal-close',    // Data attribute for close elements
        openClass   :'is-open',                 // Class added when modal is open
        debugMode   :false,                     // Enable console logging for debugging

        // ========================================
        // SCROLL & FOCUS MANAGEMENT
        // ========================================
        disableScroll:true,                     // Disable page scroll when modal is open
        disableFocus :false,                    // Disable auto-focus on first element
        backFocus    :true,                     // Return focus to trigger on close

        // ========================================
        // ANIMATIONS
        // ========================================
        awaitOpenAnimation :true,               // Wait for open animation before callbacks
        awaitCloseAnimation:true,               // Wait for close animation before removing
        animation          :'slideUp',          // Animation type: 'fade', 'slideUp', 'slideDown', 'zoom', 'flip'

        // ========================================
        // BEHAVIOR
        // ========================================
        disableEsc    :false,                   // Disable ESC key to close modal
        allowNested   :true,                    // Allow nested/stacked modals
        autoClose     :false,                   // Auto-close modal after delay
        autoCloseDelay:3000,                    // Delay in ms before auto-close

        // ========================================
        // APPEARANCE
        // ========================================
        theme   :'light',                       // Theme: 'light', 'dark', 'auto'
        size    :'default',                     // Size: 'small', 'default', 'large', 'fullscreen'
        position:'center',                      // Position: 'top', 'center', 'bottom'

        // ========================================
        // MOBILE FEATURES
        // ========================================
        dragToDismiss  :true,                    // Enable drag-to-dismiss on mobile
        dragThreshold  :100,                     // Distance in px to trigger dismiss
        swipeNavigation:false,                   // Enable swipe left/right navigation
        hapticFeedback :true,                    // Enable vibration feedback
        pullToRefresh  :false,                   // Enable pull-to-refresh gesture

        // ========================================
        // LAZY LOADING
        // ========================================
        lazyLoad  :false,                        // Enable lazy loading of content
        contentUrl:'',                           // URL to fetch content from

        // ========================================
        // CALLBACKS
        // ========================================
        onShow         :() => {
        },                 // Callback when modal is shown
        onClose        :() => {
        },                 // Callback when modal is closed
        onContentLoaded:() => {
        },                 // Callback when lazy content is loaded
        onSwipeLeft    :() => {
        },                 // Callback on swipe left gesture
        onSwipeRight   :() => {
        },                 // Callback on swipe right gesture
        onRefresh      :() => {
        },                 // Callback on pull-to-refresh

        // ========================================
        // MIDDLEWARE
        // ========================================
        beforeShow :[],                       // Array of middleware functions before show
        beforeClose:[],                       // Array of middleware functions before close

        // ========================================
        // KEYBOARD SHORTCUTS
        // ========================================
        keyboardShortcuts:{}                        // Custom keyboard shortcuts: { 'key': callback }

        // ========================================
        // PROGRAMMATIC ONLY (not for init)
        // ========================================
        // targetModal     : 'modal-id',              // ID of modal to control (used in show/close)
        // triggers        : [],                      // Array of trigger elements (auto-detected)
    };

    // Initialize BaseModal with settings
    BaseModal.init(settings);

    // Expose to window for easy access in examples
    window.BaseModal = BaseModal;

    // Initialize BaseModal.Media plugin
    window.BaseModal.Media = new BaseModalMedia({
        autoplay  :true,
        fullscreen:true,
        theme     :'dark',
        animation :'zoom',
        loading   :'lazy',
        debugMode :false
    });
    window.BaseModal.Media.init();

    // Initialize BaseModal.Inline plugin
    window.BaseModal.Inline = new BaseModalInline({
        theme    :'light',
        animation:'zoom',
        debugMode:false
    });
    window.BaseModal.Inline.init();
}
